/**
 * Kalenderwoche nach ISO 8601 (T-194, 05.10.2026: „Anzeige von Kalenderwochen
 * fehlt" — ein Ansprechpartner ist „erst in der 43. KW wieder im Hause").
 *
 * Woche beginnt montags; KW 1 ist die Woche mit dem ersten Donnerstag des
 * Jahres. Ein Tag gehört deshalb zur Woche des Jahres, in dem der Donnerstag
 * seiner Woche liegt — der 29.12.2025 zu KW 1/2026, der 01.01.2027 zu
 * KW 53/2026.
 *
 * Bewusst ohne moment: das Ergebnis darf nicht an einer Locale-Einstellung
 * hängen, und die Regel ist kurz genug, um sie hier zu lesen.
 */
export function isoKalenderwoche(d: Date): { woche: number; jahr: number } {
    // Lokaler Kalendertag als UTC-Mitternacht — so verschiebt keine
    // Sommerzeit-Umstellung die Tageszählung.
    const tag = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    const wochentag = tag.getUTCDay() || 7; // Mo = 1 … So = 7
    // Der Donnerstag derselben Woche entscheidet über Jahr und Nummer.
    tag.setUTCDate(tag.getUTCDate() + 4 - wochentag);
    const jahr = tag.getUTCFullYear();
    const jahresanfang = Date.UTC(jahr, 0, 1);
    const woche = Math.ceil(((tag.getTime() - jahresanfang) / 86_400_000 + 1) / 7);
    return { woche, jahr };
}

/** „KW 42" — mit Jahr („KW 1/2026"), wenn die Woche zum Nachbarjahr gehört. */
export function kwText(d: Date): string {
    const { woche, jahr } = isoKalenderwoche(d);
    return jahr === d.getFullYear() ? `KW ${woche}` : `KW ${woche}/${jahr}`;
}
